// LineItem/index.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';

import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';

import { getColumnHeaders } from 'utils/saleUtility';
import { formatAmount } from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

import { getUnit } from '../../redux/actions/uqc';
import { getGrayPurchasePendingIssue } from '../../redux/actions/purchaseInvoice';
import { getPendingReceiveInventories } from '../../redux/actions/receiveInventory';

import { useGlobal, useBusinessType } from 'contexts';

import LineItemTable from './LineItemTable';

const LineItem = ({
  addLineItem,
  lineItems,
  itemData,
  textColor,
  lastDaybook,
  removeLineItem,
  handleOnChange,
  companyData,
  totals,
  errors,
  handleStockModalOnClick,
  refs,
  prerefs,
  setCurrentLineItemIdx,
  type,
  warehouseList,
  lineitemview,
  selectcompany,
  lineDetailview,
  billTermData,
}) => {
  const dispatch = useDispatch();
  const [activeRow, setActiveRow] = useState(null);
  const [companySetting, setCompanySetting] = useState({});
  const [isGSTApply, setIsGSTApply] = useState(false);
  const [tempItemId, setTempItemId] = useState('');
  const [tempIndex, setTempIndex] = useState('');

  const uqcData = useSelector((state) => state.uqc?.list ?? []);
  const { businessTypes } = useBusinessType();
  const { company } = useGlobal();
  const purchase = useSelector(
    (state) => state.purchaseInvoice.grayPurchasePendingIssue ?? []
  );
  const pendingReceive = useSelector(
    (state) => state.receiveInventory.getPendingReceiveInventories ?? []
  );

  const headerBg = useColorModeValue('gray.200', '#262b33');

  // 👉 Ensure UQC list is loaded
  useEffect(() => {
    if (!uqcData || uqcData.length <= 0) {
      dispatch(getUnit());
    }
  }, [dispatch, uqcData?.length]);

  // 👉 Company settings
  useEffect(() => {
    setCompanySetting(company?.setting || {});
  }, [company?.setting]);

  // 👉 GST apply flag (kept for compatibility)
  useEffect(() => {
    if (lastDaybook?.applyGst && companySetting?.applyGST) {
      setIsGSTApply(true);
    }
  }, [companySetting?.applyGST, lastDaybook?.applyGst]);

  // 👉 Textile specific – gray purchase pending issue
  useEffect(() => {
    if (
      businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
      (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork)
    ) {
      dispatch(getGrayPurchasePendingIssue());
    }

    return () => { };
  }, [
    businessTypes?.businessType,
    dispatch,
    lastDaybook?.isMillIssue,
    lastDaybook?.isOtherJobWork,
  ]);

  // 👉 Textile specific – pending receive inventories
  useEffect(() => {
    if (businessTypes?.businessType?.toUpperCase() === 'TEXTILE') {
      dispatch(getPendingReceiveInventories());
    }
    return () => { };
  }, [
    businessTypes?.businessType,
    dispatch,
    lastDaybook?.isMillReceive,
    lastDaybook?.issuedaybookid,
  ]);

  // 👉 When item is selected, decide whether to open stock modal (serial item)
  const handleModalOpen = (value, index) => {
    setTimeout(() => {
      const selectedItem = itemData?.find(
        (item) => item.id?.toString() === value?.toString()
      );
      if (selectedItem?.itemdetailtype === 1) {
        handleStockModalOnClick(index);
      }
    }, 500);

    setTempItemId(value);
    setTempIndex(index);
  };

  useEffect(() => {
    if (!tempItemId && tempIndex === '') return;

    const selectedItem = itemData?.find(
      (item) => item.id?.toString() === tempItemId?.toString()
    );

    if (selectedItem?.itemdetailtype === 1) {
      if (type === 'recive') {
        handleStockModalOnClick(tempIndex, 'recive');
      } else if (type === 'purchase') {
        handleStockModalOnClick(tempIndex, 'purchaseinvoice');
      }
    }

    setTempIndex('');
    setTempItemId('');
  }, [itemData, tempItemId, tempIndex, type, handleStockModalOnClick]);

  // 👉 Column headers (shared between header and rows)
  const columnHeaders = getColumnHeaders(activeRow, lineItems, itemData);

  // 👉 Should warehouse column show?
  const wareshow = itemData?.some((item) =>
    lineItems?.some(
      (lineItem) => lineItem.itemId === item.id && item.itemdetailtype !== 1
    )
  );

  return (
    <Box>
      <Button
        onClick={() => addLineItem()}
        colorScheme="blue"
        mb={3}
        _focus={{}}
      >
        Add Item
      </Button>

      <LineItemTable
        textColor={textColor}
        headerBg={headerBg}
        columnHeaders={columnHeaders}
        lineItems={lineItems}
        itemData={itemData}
        uqcData={uqcData}
        businessTypes={businessTypes}
        company={company}
        companySetting={companySetting}
        lastDaybook={lastDaybook}
        selectcompany={selectcompany}
        type={type}
        wareshow={wareshow}
        lineitemview={lineitemview}
        lineDetailview={lineDetailview}
        warehouseList={warehouseList}
        purchase={purchase}
        pendingReceive={pendingReceive}
        totals={totals}
        errors={errors}
        refs={refs}
        prerefs={prerefs}
        billTermData={billTermData}
        addLineItem={addLineItem}
        removeLineItem={removeLineItem}
        handleOnChange={handleOnChange}
        handleStockModalOnClick={handleStockModalOnClick}
        handleModalOpen={handleModalOpen}
        setCurrentLineItemIdx={setCurrentLineItemIdx}
        activeRow={activeRow}
        setActiveRow={setActiveRow}
      />
    </Box>
  );
};

export default LineItem;
